import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-skeleton',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="animate-pulse">
      <!-- Profile Header Skeleton -->
      <div class="bg-purple-100 border-solid border-2 border-purple-300 p-3 sm:p-4 rounded-2xl">
        <!-- Desktop Skeleton -->
        <div class="hidden sm:flex w-full items-start gap-4">
          <!-- Avatar Skeleton -->
          <div class="w-16 h-16 bg-gray-200 rounded-full"></div>

          <!-- Info Skeleton -->
          <div class="flex-1 space-y-3">
            <div class="h-5 bg-gray-200 rounded w-1/3"></div>
            <div class="flex gap-2">
              <div class="w-8 h-8 bg-gray-200 rounded"></div>
              <div class="w-8 h-8 bg-gray-200 rounded"></div>
            </div>
            <div class="flex gap-2">
              <div class="w-24 h-8 bg-gray-200 rounded"></div>
              <div class="w-8 h-8 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>

        <!-- Mobile Skeleton -->
        <div class="sm:hidden w-full">
          <div class="flex justify-between gap-4">
            <div class="flex gap-4">
              <div class="w-16 h-16 bg-gray-200 rounded-full"></div>
              <div class="space-y-2">
                <div class="h-5 bg-gray-200 rounded w-24"></div>
                <div class="flex gap-2">
                  <div class="w-6 h-6 bg-gray-200 rounded"></div>
                  <div class="w-6 h-6 bg-gray-200 rounded"></div>
                </div>
              </div>
            </div>
            <div class="flex gap-2">
              <div class="w-8 h-8 bg-gray-200 rounded"></div>
              <div class="w-8 h-8 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pay Button Skeleton -->
      <div class="h-10 bg-gray-200 rounded mt-4"></div>

      <!-- Payment Methods Skeleton -->
      <div class="mt-6 bg-bg-gray p-3 rounded-xl">
        <div class="flex gap-2">
          <div class="w-8 h-8 bg-gray-200 rounded-full"></div>
          <div class="w-8 h-8 bg-gray-200 rounded-full"></div>
          <div class="w-8 h-8 bg-gray-200 rounded-full"></div>
        </div>
      </div>

      <!-- Bio Skeleton -->
      <div class="space-y-2 mt-4">
        <div class="h-4 bg-gray-200 rounded"></div>
        <div class="h-4 bg-gray-200 rounded w-5/6"></div>
      </div>
    </div>
  `,
})
export class LoadingSkeletonComponent {}
